// extracted by mini-css-extract-plugin
export default {"wrapper":"pre-wrap-module--wrapper--2deba"};